import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ num, label }) => (
  <div className="flex items-center gap-3 mb-5" data-testid={`chapter-${num}`}>
    <span className="font-mono-brand text-xs text-brand font-medium">{num}</span>
    <span className="h-px w-10 bg-brand/60" />
    <span className="text-xs font-semibold tracking-[0.2em] uppercase text-zinc-500">{label}</span>
  </div>
);
